var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0013 2.16669C7.03213 2.16669 2.16797 7.03085 2.16797 13C2.16797 18.9692 7.03213 23.8334 13.0013 23.8334C18.9705 23.8334 23.8346 18.9692 23.8346 13C23.8346 7.03085 18.9705 2.16669 13.0013 2.16669ZM18.1796 10.5084L12.0371 16.6509C11.8848 16.803 11.6783 16.8885 11.463 16.8885C11.2477 16.8885 11.0411 16.803 10.8888 16.6509L7.82297 13.585C7.67186 13.4321 7.58712 13.2258 7.58712 13.0109C7.58712 12.7959 7.67186 12.5896 7.82297 12.4367C8.13713 12.1225 8.65713 12.1225 8.9713 12.4367L11.463 14.9284L17.0313 9.36002C17.3455 9.04585 17.8655 9.04585 18.1796 9.36002C18.4938 9.67419 18.4938 10.1834 18.1796 10.5084Z",
    fill: "#19A089"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e09a87e9ee305e6632da6b4ea31dc0f8.svg";
export { ForwardRef as ReactComponent };